//@codekit-prepend "modules/header-slideshow.js"
//@codekit-prepend "modules/menu.js"
//@codekit-prepend "modules/pattern-parallax.js"
//@codekit-prepend "modules/collection-grid.js"
//@codekit-prepend "modules/info-modal.js"
//@codekit-prepend "modules/order-modal.js"
//@codekit-prepend "modules/floating-block.js"
//@codekit-prepend "modules/pattern-heading.js"
//@codekit-prepend "modules/publications.js"
//@codekit-prepend "modules/content-slideshow.js"
//@codekit-prepend "modules/animate-in.js"





var ajaxurl     =  '/wp-admin/admin-ajax.php';
var winHeight   =  window.innerHeight;
var winwidth    =  window.innerWidth;

var cookieconsentModal = new bootstrap.Modal(document.getElementById('cookieconsent'), {
    keyboard: false,
  backdrop: 'static', 
  });  

function appendHtml(el, str) {
	var div = document.createElement('div');
	div.innerHTML = str;
	while (div.children.length > 0) {
		el.appendChild(div.children[0]);
	}
}

function offset( elem ) {

    var docElem, win,
        box = { top: 0, left: 0 },
        doc = elem && elem.ownerDocument;

    docElem = doc.documentElement;

    if ( typeof elem.getBoundingClientRect !== typeof undefined ) {
        box = elem.getBoundingClientRect();
    }
    win = getWindow( doc );
    return {
        top: box.top + win.pageYOffset - docElem.clientTop,
        left: box.left + win.pageXOffset - docElem.clientLeft
    };
};

function getWindow( elem ) {
    return isWindow( elem ) ? elem : elem.nodeType === 9 && elem.defaultView;
}

function isWindow( obj ) {
    return obj != null && obj === obj.window;
}

const loadAsyncScript = (src, async = true, type = "text/javascript") => {
    return new Promise((resolve, reject) => {
        try {
            const el = document.createElement("script");
            const container = document.head || document.body;

            el.type = type;
            el.async = async;
            el.src = src;

            el.addEventListener("load", () => {
                resolve({ status: true });
            });

            el.addEventListener("error", () => {
                reject({
                    status: false,
                    message: `Failed to load the script ${src}`
                });
            });

            container.appendChild(el);
        } catch (err) {
            reject(err);
        }
    });
};

function serialiseForm(e) {
    const formData = new FormData(e.target);
    return Object.fromEntries(formData.entries());
  }

function loadingAni() {

    function show(container, state, position){

        let ajaxHtml = `<div class="ajax-loading ajax-loading-pos ajax-loading-${position}"><div class="lds-dual-ring"></div></div>`;

        if (state === 'neg') {
            ajaxHtml = `<div class="ajax-loading ajax-loading-neg  ajax-loading-${position}"><div class="lds-dual-ring"></div></div>`;
        }

        appendHtml(container, ajaxHtml); 
    }
    function hide(){
        const ajaxLoader = document.querySelector('.ajax-loading');
        if (ajaxLoader) {
              ajaxLoader.parentNode.removeChild(ajaxLoader);  
        }

    }
    return {
        show: show,
        hide: hide
    }
}

const loading = new loadingAni();


if (document.querySelector('#header-slider-holder')) {
    const headerSwiper = new headerSlider();
}

if (document.querySelector('.pattern-parallax')) {
    const patternParalax = new initPatternParallax();
}

if (document.querySelector('.post-type-archive-collection')) {
    const collectionGrid = new initCollectionGrid(); 
}

if (document.querySelector('.colletion-btn')) {

    const infoModal = new initInfoModal();
}

if (document.querySelector('.floating-block')) {

    const floatingBlock = new initFloatingBlock();
}

if (document.querySelector('.pattern-heading-block')) {

    const patternHeading = new initPatternHeading();
}

if (document.querySelector('.publication-single')) {

    const publications = new initPublications();
}

if (document.querySelector('.order-publication-btn')) {

    const orderModal = new initOrderModal();
}


if (document.querySelector('.animate-in')) {

    const animateIn = new initAnimateIn();
}


 

const slideshows = document.querySelectorAll('.content-slider-holder');

if (slideshows) {

    slideshows.forEach(slideshow => {
   
        const contentSlideShow = new contentSlider(slideshow);

    })
}


const menu = new initMenu() ;


function loadGAonConsent() {


}

function initCookieDisclaimer(){

				var exdays = 30;
				var $acceptAll =        document.querySelector('.btn-acceptAll');
				//var $acceptPart =       document.querySelector('.btn-AcceptPart');

				var cookieCheckTechnical = document.querySelector('#cookieconsent #cookieCheckTechnical');
				//var cookieCheckStatsitik = document.querySelector('#cookieconsent  #cookieCheckStatsitik');

				 setTimeout(function(){
					  cookieCheckTechnical.checked = true;
				  },1000);


				function setCookie(cname, cvalue, exdays) {
					var d = new Date();
					d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
					var expires = "expires="+d.toUTCString();
					document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
				}

				function getCookie(cname) {
					var name = cname + "=";
					var ca = document.cookie.split(';');
					for(var i = 0; i < ca.length; i++) {
					var c = ca[i];
					while (c.charAt(0) == ' ') {
					c = c.substring(1);
					}
					if (c.indexOf(name) == 0) {

					return c.substring(name.length, c.length);

					}
					}
					return ""; 
				}

				function injectScript(source) {

					var Script = document.createElement("script");
					var inlineScript = document.createTextNode(source);
					Script.appendChild(inlineScript); 
					document.getElementsByTagName('head')[0].appendChild(Script);


				}

				function technicalHook() {

				}

				function statsitikHook() {

                    loadGAonConsent();

				}

				function komfortHook() {

				}

				function checkCookie() {

					var cookieCheckTechnicalVal = getCookie('cookieCheckTechnicalVal');
					//var cookieCheckStatsitikVal = getCookie('cookieCheckStatsitikVal');

					if (cookieCheckTechnicalVal == 'true') {

						technicalHook();
						cookieCheckTechnical.checked = true;
					} else {

						cookieCheckTechnical.checked = false;
					}
                
					/*
					if (cookieCheckStatsitikVal == 'true') {
						
						//statsitikHook();
				       // cookieCheckStatsitik.checked = true;
						
					} else {
						
						cookieCheckStatsitik.checked = false;
						
						 
					}
                 
					*/
					
					
					
				}
				
               /*
				
				$acceptPart.addEventListener("click",function(e){
					
					
					var cookieCheckTechnicalVal 	= false;
					//var cookieCheckStatsitikVal 	= false;
					
					
					
					
					
					
					
					
					if (cookieCheckTechnical.checked) {
						
						cookieCheckTechnicalVal = true;
					}
                    
             
				
					if (cookieCheckStatsitik.checked) {
						
						cookieCheckStatsitikVal = true;
					}
               
					
					
					
					 setCookie('cookieCheckTechnicalVal', cookieCheckTechnicalVal, exdays);
					 //setCookie('cookieCheckStatsitikVal', cookieCheckStatsitikVal, exdays);
					
					 setCookie('cookieConsent', true, exdays);
					 location.reload();
					
					cookieconsentModal.hide();
					
					
					
				},false);
				
			*/
				$acceptAll.addEventListener("click",function(e){
					
					
					var cookieCheckTechnicalVal 	= true;
					//var cookieCheckStatsitikVal 	= true;
					
					
					
					 setCookie('cookieCheckTechnicalVal', cookieCheckTechnicalVal, exdays);
					// setCookie('cookieCheckStatsitikVal', cookieCheckStatsitikVal, exdays);
					
					 setCookie('cookieConsent', true, exdays);
					
					cookieconsentModal.hide();
					
					location.reload();
					
				},false);
				
				
				
				
				checkCookie();
				
				
				if (getCookie('cookieConsent').length) {
					
					
					
				} else {
					
					 cookieconsentModal.show();
					
				}
				
				
				


            } 
			 
function setCookie(cname, cvalue, exdays) {
    var d = new Date();
    d.setTime(d.getTime() + (exdays*24*60*60*1000));
    var expires = "expires="+ d.toUTCString();
    document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
  }

function getCookie(cname) {
    var name = cname + "=";
    var decodedCookie = decodeURIComponent(document.cookie);
    var ca = decodedCookie.split(';');
    for(var i = 0; i <ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) == ' ') {
        c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
        return c.substring(name.length, c.length);
      }
    }
    return false;
  }
  initCookieDisclaimer();
